"use client";
import { DialogTitle } from "@headlessui/react";
import { ModalTitle } from "@offstreetparking/design-system/overlay";
import { useFlowOverlayContainment } from "../../../host/overlay-containment";

type FlowModalTitleProps = Parameters<typeof ModalTitle>[0];

export const FlowModalTitle = (props: FlowModalTitleProps) => {
	const contained = useFlowOverlayContainment();
	if (!contained) {
		return <ModalTitle {...props} />;
	}
	return <h3 className="mb-4 font-semibold text-base text-neutral leading-5">{props.children}</h3>;
};

export const FlowDialogTitle = ({ className, children }: { className?: string; children: React.ReactNode }) => {
	const contained = useFlowOverlayContainment();
	if (!contained) {
		return <DialogTitle className={className}>{children}</DialogTitle>;
	}
	return <h2 className={className}>{children}</h2>;
};
